export const environment = {
  production: true,
  apiurl : '#{API_URL}#',
  appInsights: {
    instrumentationKey: '#{Azure_ApplicationInsightKey}#'
  }
};
